import type { ChatMode } from '@/services/chatService';
import type { AppMode } from '@/hooks/useEffectiveMode';

/**
 * Mapeo único entre AppMode (UI/ruta) y ChatMode (BD).
 * Cada cuerpo de oposición tiene su propio chat_mode aislado en la BD.
 */
export function appModeToChatMode(mode: AppMode): ChatMode {
  switch (mode) {
    case 'oposiciones_c1': return 'oposiciones_c1';
    case 'oposiciones_guardia_civil': return 'oposiciones_guardia_civil';
    case 'oposiciones_policia_nacional': return 'oposiciones_policia_nacional';
    case 'oposiciones_iipp': return 'oposiciones_iipp';
    case 'oposiciones_c2': return 'oposiciones_c2';
    case 'oposiciones_generico': return 'oposiciones_generico';
    case 'base_comun': return 'oposiciones_generico';
    case 'oposiciones': return 'oposiciones';
    default: return 'funcionarios';
  }
}

/**
 * Devuelve la ruta base (/app/...) según el chat_mode almacenado.
 */
export function chatModeToBasePath(mode: string | null | undefined): string {
  switch (mode) {
    case 'oposiciones_c1': return '/app/oposiciones-c1';
    case 'oposiciones_guardia_civil': return '/app/guardia-civil';
    case 'oposiciones_policia_nacional': return '/app/policia-nacional';
    case 'oposiciones_iipp': return '/app/oposiciones-iipp';
    case 'oposiciones_c2': return '/app/oposiciones-c2';
    case 'oposiciones_generico': return '/app/base-comun';
    case 'oposiciones': return '/app/oposiciones';
    default: return '/app';
  }
}

export function getChatUrl(chatId: string, mode: string | null | undefined): string {
  return `${chatModeToBasePath(mode)}/chat/${chatId}`;
}
